import assign from "lodash/assign";

import ChatActions from "../../actions/ChatActions";
import alt from "../../alt/ChatAlt";

class ConfigStore {
    constructor() {
        this.bindActions(ChatActions);
        this.config = {};
    }

    onUpdateConfig(nextConfigState) {
        this.setState({
            config: assign({}, this.config, nextConfigState),
        });
    }

    static getConfig() {
        return this.getState().config;
    }
}

export default alt.createStore(ConfigStore, "ConfigStore");
